import Cafes from './Cafes';

export default Cafes;
